import React, { useState } from "react";

const FOCUS_CARDS_CSS = `
  .fc-grid{
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:28px;
    max-width:1100px;
    margin:0 auto;
    width:100%;
  }
  @media (max-width:900px){ .fc-grid{grid-template-columns:repeat(2,1fr);gap:20px;} }
  @media (max-width:560px){ .fc-grid{grid-template-columns:1fr;} }

  .fc-card{
    position:relative;
    overflow:hidden;
    width:100%;
    height:340px;
    border-radius:10px;
    background:#e9e6dc;
    cursor:pointer;
    outline:none;
    transition:filter .3s ease, transform .3s ease, box-shadow .3s ease;
    box-shadow:0 4px 14px rgba(14,36,54,.12);
  }
  @media (max-width:560px){ .fc-card{height:240px;} }
  .fc-card.fc-dim{filter:blur(4px);transform:scale(.98);}
  .fc-card:focus-visible{box-shadow:0 0 0 3px #c98a2e;}

  .fc-card img.fc-img{
    position:absolute;
    top:0;left:0;
    width:100%;
    height:100%;
    max-width:none;
    object-fit:cover;
    display:block;
  }

  .fc-label{
    position:absolute;
    left:0;right:0;bottom:0;
    padding:34px 18px 16px;
    background:linear-gradient(to top, rgba(14,36,54,.85), transparent);
    color:#fff;
    font-family:"Iowan Old Style","Palatino Linotype",Georgia,serif;
    font-size:1.15rem;
    font-weight:600;
  }

  .fc-overlay{
    position:absolute;
    inset:0;
    background:rgba(14,36,54,.55);
    display:flex;
    align-items:flex-end;
    padding:28px 20px;
    opacity:0;
    transition:opacity .3s ease;
  }
  .fc-card.fc-hover .fc-overlay{opacity:1;}
  .fc-overlay span{
    color:#fff;
    font-family:"Iowan Old Style","Palatino Linotype",Georgia,serif;
    font-size:1.5rem;
    font-weight:600;
  }
  .fc-overlay small{
    display:block;
    margin-top:6px;
    font-family:"Helvetica Neue",Arial,sans-serif;
    font-size:.72rem;
    letter-spacing:.14em;
    text-transform:uppercase;
    color:#e8b765;
  }
`;

export const Card = React.memo(({ card, index, hovered, setHovered, onSelect, ctaText }) => {
  const isHover = hovered === index;
  const isDim = hovered !== null && hovered !== index;
  return (
    <div
      role="button"
      tabIndex={0}
      className={`fc-card${isHover ? " fc-hover" : ""}${isDim ? " fc-dim" : ""}`}
      onMouseEnter={() => setHovered(index)}
      onMouseLeave={() => setHovered(null)}
      onFocus={() => setHovered(index)}
      onBlur={() => setHovered(null)}
      onClick={() => onSelect?.(card, index)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect?.(card, index);
        }
      }}
    >
      <img className="fc-img" src={card.src} alt={card.title} />
      <div className="fc-label">{card.title}</div>
      <div className="fc-overlay">
        <div>
          <span>{card.title}</span>
          <small>{ctaText}</small>
        </div>
      </div>
    </div>
  );
});

Card.displayName = "Card";

export function FocusCards({ cards, onSelect, ctaText = "Read guide →" }) {
  const [hovered, setHovered] = useState(null);

  return (
    <>
      <style>{FOCUS_CARDS_CSS}</style>
      <div className="fc-grid">
        {cards.map((card, index) => (
          <Card
            key={card.id ?? card.title}
            card={card}
            index={index}
            hovered={hovered}
            setHovered={setHovered}
            onSelect={onSelect}
            ctaText={ctaText}
          />
        ))}
      </div>
    </>
  );
}